<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div>
				<table class="table table-hover ui-table">
					<thead>
						<tr>
							<th>{{ $t('invoice.title') }}</th>
							<th>{{ $t('invoice.grade') }}</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="resources && resources.length">
							<tr v-for="(resource, index) in resources" :key="index" @dblclick="pickItem(resource)">
								<td>{{ resource.remark }}</td>
								<td>{{ resource.grade_name_foreign }}</td>
							</tr>
						</template>

						<tr v-else class="no-data-row">
							<td colspan="2" class="no-data-cell">
								<i class="fa fa-inbox no-data-icon"></i>
								<div>No data available</div>
							</td>
						</tr>

					</tbody>
				</table>
			</div>
		</ts-loading-banner>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'PredefinedItem',
	props: ['isActive', 'value'],
	data() {
		return {
			loading: false,
			model: {},
			resources: []
		}
	},
	created() {
		this.model = this.value
	},
	methods: {
		...mapActions('invoice', [
			'getFormViewModel'
		]),
		fetchItem() {
			this.loading = true
			this.getFormViewModel({
				fnName: 'predefineItem',
				gradeId: this.model.grade_id
			})
				.then((response) => {
					this.resources = response.predefineItem
				})
				.finally(() => this.loading = false)
		},
		pickItem(item) {
			this.$emit('set-item', item.details)
		}
	},
	watch: {
		isActive: function (id) {
			if (id == 5) {
				this.fetchItem()
			}
		}
	}
}

</script>

<style lang="css" scoped>
#container-table {
	max-height: 35vh;
	height: 30vh;
}

.table>thead>tr>th {
	padding: 5px 15px;
}

.table>tbody>tr>td {
	padding-top: 5px !important;
	padding-bottom: 5px !important;
	cursor: pointer;
	font-size: 12px !important;
}

.no-data-cell {
	text-align: center;
	padding: 30px;
	color: #999;
}

.no-data-icon {
	font-size: 28px;
	margin-bottom: 6px;
	display: block;
}
</style>